import { InjectionToken } from "@angular/core";

export const LOGGED_IN_AT = "loggedInAt";
export const SESSION_DURATION = "sessionDuration";
export const LOCATION = new InjectionToken("LOCATION");
export const LOCAL_STORAGE = new InjectionToken("LOCAL_STORAGE");
export const SESSION_STORAGE = new InjectionToken("SESSION_STORAGE");
